const Video = () => {
  const imgIcon =
    'https://www.figma.com/api/mcp/asset/3617eba9-0353-4956-859a-b711c8ada1fa';

  return (
    <div
      className="content-stretch flex items-center justify-center relative size-full bg-black rounded-[16px]"
      data-name="Container"
      data-node-id="953:33533"
    >
      <div
        className="backdrop-blur-[2px] bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.1)] border-solid content-stretch flex items-center justify-center pl-[18px] pr-[14px] py-px relative rounded-[9999px] shrink-0 size-[80px]"
        data-name="Button - Play video"
        data-node-id="953:33534"
      >
        <div
          className="relative shrink-0"
          data-name="Container"
          data-node-id="953:33535"
        >
          <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start relative">
            <div className="flex items-center justify-center relative shrink-0">
              <div className="-scale-y-100 flex-none">
                <div
                  className="relative size-[48px]"
                  data-name="Icon"
                  data-node-id="953:33536"
                >
                  <img
                    alt=""
                    className="block max-w-none size-full"
                    src={imgIcon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
